import { Spine } from '@esotericsoftware/spine-pixi-v7'
import { Assets, Container, Sprite, TextStyle, Text } from 'pixi.js'
import { path, settings } from '../settings.js'
import { config } from './appConfig.js'
// import { Spine } from 'pixi-spine'
import { resolveAndKillTweens, tweenFadeAppear } from './utility.js'
import gsap from 'gsap'

let pixiApp
const progressBarContainer = new Container()
const progressBarBG = new Sprite()
const progressBar = new Sprite()
const progressBarShadow = new Sprite()
const jeepneyLogo = new Sprite()
const logo = new Sprite()
const bg = new Sprite()
export let timeOut;
// const chickenAnimation = null;
const loadingTxtStyle = new TextStyle({
  fill: 0x0000ff,
  fontWeight: 'bold',
  fontSize: 17
})
const loadingPercent = new Text('0%', loadingTxtStyle)
const loadingTxt = new Text('Loading ', loadingTxtStyle)
let spineCharacter = null;
export let bgLady = null;
export let lady = null;
export async function createProgressBar(app) {
  pixiApp = app

  if (!pixiApp) return

  pixiApp.app.stage.addChild(progressBarContainer)

  const appWidth = pixiApp.app.screen.width
  const appHeight = pixiApp.app.screen.height

  const scaleFactor = Math.min(appWidth / settings.originalWidth, appHeight / settings.originalHeight)

  Assets.addBundle('Image', {
    knifeData: path.spine + 'loading screen.json',
    knifeAtlas: path.spine + 'loading screen_export.atlas'
  })

  Assets.add('bg', path.imagePath + 'backDrop.png')
  await Assets.load('bg')


  await Assets.loadBundle('Image')

  Assets.add('fruit', path.imagePath + 'loadingScreen.png')
  await Assets.load('fruit')

  Assets.add('logo', path.imagePath + 'logo.png')
  await Assets.load('logo')

  Assets.add('progressBar', path.imagePath + 'loading_bar_yellow.png')
  await Assets.load('progressBar')

  Assets.add('progressBarWhite', path.imagePath + 'loading_bar white.png')
  await Assets.load('progressBarWhite')

  Assets.add('progressBarShadow', path.imagePath + 'loading_bar_shadow.png')
  await Assets.load('progressBarShadow')


  bg.texture = await Assets.load('bg')
  bg.anchor.set(0.5)
  bg.x = config.logicalWidth * 0.5
  bg.y = window.innerHeight * 1.18
  bg.scale.set(2.6, 2.6)

  jeepneyLogo.texture = await Assets.load('fruit')
  jeepneyLogo.anchor.set(0.5)
  jeepneyLogo.x = config.logicalWidth * 0.5
  jeepneyLogo.y = config.logicalHeight * 0.5 
  jeepneyLogo.scale.set(1)

  logo.texture = await Assets.load('logo')
  logo.anchor.set(0.5)
  logo.x = config.logicalWidth * 0.5
  logo.y = config.logicalHeight * 0.15
  logo.scale.set(1.25)


  progressBarBG.texture = await Assets.load('progressBarWhite')
  progressBarBG.anchor.set(0.5)
  // progressBarBG.tint = 0x303030;
  progressBarBG.x = config.logicalWidth * 0.56
  progressBarBG.y = config.logicalHeight * 0.87
  // progressBarBG.scale.x = scaleFactor
  // progressBarBG.scale.y = scaleFactor

  progressBarShadow.texture = await Assets.load('progressBarShadow')
  progressBarShadow.anchor.set(0.5)
  progressBarShadow.scale.set(1.22, 1.55)
  // progressBarBG.tint = 0x303030;
  progressBarShadow.x = 714
  progressBarShadow.y = config.logicalHeight * 0.85

  progressBar.texture = await Assets.load('progressBar')
  progressBar.anchor.set(0, 0.5)
  progressBar.x = -progressBarBG.width / 2
  progressBar.y = 0
  progressBar.scale.y = 1
  progressBar.scale.x = 0

  // const spineData = await Assets.load('chicken');
  // spineCharacter = new Spine((spineData).spineData)

  spineCharacter = Spine.from({ skeleton: "knifeData", atlas: "knifeAtlas" });
  spineCharacter.scale.set(0.7)
  spineCharacter.state.setAnimation(0, 'knife', true)

  spineCharacter.x = -progressBarBG.width / 2 + ((progressBar.scale.x * 80) * progressBarBG.width / 100)
  spineCharacter.visible = false

  bgLady = Spine.from({ skeleton: "knifeData", atlas: "knifeAtlas" });
  bgLady.state.setAnimation(0, 'rays', true)
  bgLady.y = config.logicalHeight - 100
  bgLady.x = config.logicalWidth / 2

  lady = Spine.from({ skeleton: "knifeData", atlas: "knifeAtlas" });
  lady.state.setAnimation(0, 'sexy character_idle', true)

  timeOut = setInterval(() => {
    lady.state.setAnimation(0, 'sexy character_wink', false).listener = {
      complete: () => {
        lady.state.setAnimation(0, 'sexy character_idle', true)
      }
    };
  }, 7000)
  lady.y = config.logicalHeight - 285
  lady.x = config.logicalWidth / 2
  lady.scale.set(1, 0.95)
  progressBarBG.addChild(progressBar, spineCharacter)
  // progressBar.scale.y = scaleFactor

  loadingTxt.x = progressBarBG.x - loadingTxt.width / 2 - loadingPercent.width
  loadingTxt.y = progressBarBG.y + loadingTxt.height * 2

  loadingPercent.x = loadingTxt.x + loadingTxt.width
  loadingPercent.y = loadingTxt.y


  progressBarContainer.addChild(bg, jeepneyLogo, bgLady, logo, lady, progressBarBG)
  progressBarContainer.visible = true
  resizeLoadingScreen();
}

export function resizeLoadingScreen() {

  if (window.innerWidth < 500) {
    progressBarContainer.x = 0
    const scaleX = window.innerWidth / config.logicalWidth;
    progressBarContainer.scale.set(scaleX, config.minScaleFactor);
  }
  else {
    progressBarContainer.x = config.minLeftX
    progressBarContainer.scale.set(config.minScaleFactor);
  }
  progressBarContainer.y = config.minTopY
}

async function tweenFade(gameObject) {
  const duration = 0.15

  resolveAndKillTweens(gameObject)
  const tl = gsap.timeline()
  await tl.to(gameObject, {
    alpha: 0,
    duration,
    ease: 'sine.in',
  })
}

export const fadeProgressBar = () => {
  jeepneyLogo.visible = false;
  logo.visible = false
  progressBarBG.visible = false

  // progressBarShadow.visible = false;
}


export function assetsLoadProgress(progress) {
  if (!pixiApp) return
  // loadingPercent.text = Math.floor(progress * 100) + '%'

  progressBar.scale.x = progress
  if (spineCharacter) {
    spineCharacter.visible = true
    spineCharacter.x = -progressBarBG.width / 2 + ((progressBar.scale.x * 80) * progressBarBG.width / 100)
  }
  //spineCharacter.x = progressBar.width - progressBarBG.width / 2 - 180
  if (progress > 0.99) {
    // assets load complete
  }
}